// extracted by mini-css-extract-plugin
export var autoExpand = "_3g-b";
export var container = "_3g-a";
export var containerWidth = "_3g-8";
export var disabled = "_3g-2";
export var error = "_3g-3";
export var fullWidth = "_3g-9";
export var highlightContainer = "_3g-5";
export var inputWrapper = "_3g-0";
export var small = "_3g-1";
export var textarea = "_3g-4";
export var validatedTextarea = "_3g-6";
export var visuallyHidden = "_3g-7";